import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tenant-settings/roles")({
  component: () => (
    <Navigate to="/tenant-settings/users" search={{ tab: "roles" }} />
  ),
});
